<template>
 <div class="bg-white rounded-lg shadow">
  <apexchart width="100%" :options="chartOptions" :series="series" />
 </div>
</template>

<script>
export default {
 name: "RadialBarChart",
 props: {
  series: {
   type: Array,
   required: true,
  },
  labels: {
   type: Array,
  },
  title: {
   type: String,
   default: "Performance Metrics",
  },
  size: {
   type: String,
   default: "100%",
  },
 },
 data() {
  return {
   series: [this.series],
   chartOptions: {
    chart: {
     type: "radialBar",
     offsetY: -10,
    },
    plotOptions: {
     radialBar: {
      startAngle: -135,
      endAngle: 135,
      dataLabels: {
       name: {
        fontSize: "12px",
        color: undefined,
        offsetY: 120,
       },
       value: {
        offsetY: 76,
        fontSize: "18px",
        color: undefined,
        formatter: function (val) {
         return val + "%";
        },
       },
      },
     },
    },
    fill: {
     type: "gradient",
     gradient: {
      shade: "dark",
      shadeIntensity: 0.15,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 50, 65, 91],
     },
    },
    stroke: {
     dashArray: 4,
    },
    labels: this.labels,
   },
  };
 },
 computed: {},
};
</script>
